/**
 * Entry point for the application
 */

function initApp(): void {
  const button = document.getElementById('helloBtn') as HTMLButtonElement;
  const messageDiv = document.getElementById('message') as HTMLDivElement;
  const qrButton = document.getElementById('qrBtn') as HTMLButtonElement;
  const mapsButton = document.getElementById('mapsBtn') as HTMLButtonElement;

  if (!button || !messageDiv) {
    console.error('Required DOM elements not found');
    return;
  }

  button.addEventListener('click', () => {
    handleButtonClick(messageDiv);
  });

  // QR Payment button
  if (qrButton) {
    qrButton.addEventListener('click', () => {
      handleQRPayment();
    });
  }

  // Google Maps button (for testing intents on emulator)
  if (mapsButton) {
    mapsButton.addEventListener('click', () => {
      handleOpenMaps();
    });
  }
}

function handleButtonClick(messageDiv: HTMLDivElement): void {
  const messages: string[] = [
    '¡Hola Mundo!',
    '¡Bienvenido!',
    '¡Saludos!'
  ];

  const randomMessage = messages[Math.floor(Math.random() * messages.length)];

  const textElement = messageDiv.querySelector('p');
  if (textElement) {
    textElement.textContent = randomMessage;
  }

  messageDiv.classList.remove('opacity-0');
  messageDiv.classList.add('opacity-100');

  setTimeout(() => {
    messageDiv.classList.remove('opacity-100');
    messageDiv.classList.add('opacity-0');
  }, 3000);

  console.log(`Button clicked: ${randomMessage}`);
}

/**
 * Opens a dynamic link with automatic click after delay
 * Supports Android intent URIs for app deep linking
 * @param url - The URL or intent URI to open
 * @param delay - Delay in milliseconds before opening (default: 100)
 */
function openDynamicLink(url: string, delay: number = 100): void {
  const link = window.top!.document.createElement('a');
  link.target = '_top';
  link.href = url;

  // For visibility during testing
  link.style.display = 'none';
  document.body.appendChild(link);

  console.log(`Opening link in ${delay}ms:`, url);

  setTimeout(() => {
    link.click();
    // Clean up after click
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
  }, delay);
}

/**
 * Handle QR payment link - Example with Onepay intent URI
 */
function handleQRPayment(): void {
  // Detect if it's Android
  const isAndroid = /Android/i.test(navigator.userAgent);

  if (isAndroid) {
    // openDynamicLink(onepayIntentUri, 100);
    const onepayIntentUri = 'intent://deeplink.webpay3g.transbank.cl/webpayserver/pagoqr/onepay?simple_code=H4851171#Intent;scheme=https;package=cl.transbank.onepay;S.browser_fallback_url=https://play.google.com/store/apps/details?id=cl.transbank.onepay;end';
    var t = window.top?.document.createElement("a");
    if (!t) {
      alert("Unable to create link element for QR payment.");
      return;
    }
    t.target = "_top",
      t.href = onepayIntentUri,
      setTimeout(function () {
        if (!t) {
          alert("Unable to create link element for QR payment.");
          return;
        }
        t.click();
        document.body.removeChild(t);
      }, 100)
  } else {
    // Fallback for iOS/Desktop - use direct HTTPS link
    const fallbackUrl = 'https://deeplink.webpay3g.transbank.cl/webpayserver/pagoqr/onepay?simple_code=H4851171';
    openDynamicLink(fallbackUrl, 100);
  }
}

/**
 * Handle opening Maps app with platform-specific URI
 * Uses La Moneda, Santiago, Chile as example location
 * 
 * Behavior similar to Onepay:
 * - HTTPS links open in system browser (_top/_system) -> triggers app
 * - HTTPS links do NOT work in InAppBrowser (_blank)
 */
function handleOpenMaps(): void {
  const userAgent = navigator.userAgent;
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  
  // La Moneda, Santiago, Chile coordinates
  const lat = -33.4425;
  const lng = -70.6539;
  const label = 'La Moneda, Santiago';

  console.log('Platform detection:', { isAndroid, isIOS, userAgent });

  if (isAndroid) {
    // Android intent URI for Google Maps
    const mapsIntentUri = `intent://maps.google.com/maps?q=${lat},${lng}(${encodeURIComponent(label)})#Intent;scheme=https;package=com.google.android.apps.maps;S.browser_fallback_url=https://maps.google.com/?q=${lat},${lng};end`;
    
    console.log('Opening Android Maps intent:', mapsIntentUri);
    
    const link = window.top?.document.createElement('a');
    if (!link) {
      alert('Unable to create link element for Maps.');
      return;
    }
    // link.target = '_top';
    link.href = mapsIntentUri;
    document.body.appendChild(link);
    
    setTimeout(() => {
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    }, 100);
  } else if (isIOS) {
    // iOS - Use HTTPS Apple Maps link (like Onepay pattern)
    // This only works when opened in system browser (_top/_system)
    // Does NOT work in InAppBrowser (_blank)
    const appleMapsUrl = `https://maps.apple.com/?q=${lat},${lng}&ll=${lat},${lng}`;
    
    console.log('Opening Apple Maps (HTTPS, needs _system/_top):', appleMapsUrl);
    
    const link = window.top?.document.createElement('a');
    if (!link) {
      alert('Unable to create link element for Maps.');
      return;
    }
    // link.target = '_top';  // Opens in system browser, which will trigger Maps app
    link.href = appleMapsUrl;
    document.body.appendChild(link);
    
    setTimeout(() => {
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    }, 100);
  } else {
    // Desktop fallback - use Google Maps web
    const fallbackUrl = `https://maps.google.com/?q=${lat},${lng}`;
    console.log('Opening Maps fallback (Desktop):', fallbackUrl);
    openDynamicLink(fallbackUrl, 500);
  }
}

// Initialize app when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

export { };
